const snack = require("../snack/snack");
const itemDt = require('../../applications/staff/desktop/entity/item/item-dt')
const itemFullcont = require('../../applications/staff/desktop/entity/item/item-fullcont')

async function DB(detail, phpFile) {
  try {
    const response = await fetch(phpFile, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(detail),
    });

    const result = await response.json();

    if (result.status !== "ok") {
      throw new Error(result.message || "Error desconocido");
    }

    return result;
  } catch (error) {
    //console.error("Error en la petición:", error);
    throw error;
  }
}

export function updateAvatar(detail, htmlFc, callback) {
  const entity = detail.entity;
  setTimeout(() => {
    const phpFile = "server/php/sql/dalle.php";

    DB(detail, phpFile)
      .then((result) => {
        itemDt.start({dest: entity, elem: 'dt', act: 'select', entity})
        itemFullcont.resetFullcont(detail, htmlFc)
      })
      .catch((error) => {
        //console.log("error UPDATE ONE", error);
        throw error;
      });
  }, 1000);
}

